module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "on-dark",
    staticStyle: {
      "margin-top": "-0.3px",
      "font-size": "18px"
    }
  }, [_vm._v("Shopping Cart")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.cart.length) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "1.4em"
    }
  }, [_vm._m(1), _vm._v(" "), _c('component-footer')], 1) : _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('cart-widget')], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center"
    }
  }, [_vm._v("Your cart is empty,")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "padding": "0.5em",
      "background": "#ffa800",
      "color": "#000000"
    },
    attrs: {
      "href": "/timeline"
    }
  }, [_vm._v("Start Buying")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17545af8"}!./src/pages/Orderpoint/Cart/template.html
// module id = 373
// module chunks = 0